import loadable from "@loadable/component";
import { ContentCard } from "@tvg/fuse/content-card";
import useGlobalConfig from "client/context/GlobalConfig";
import getImageSources from "client/utils/getImageSources";
import React, { useMemo } from "react";
import { AmpCardGroupItem, AmpCardImageRatio } from "types/amplience";

export interface CardProps {
  config: AmpCardGroupItem;
  headerTag: "h3" | "h2";
  imageRatio: AmpCardImageRatio;
}

const VideoPlayer = loadable(() => import(/* webpackChunkName: "VideoPlayer" */ "../VideoPlayer/VideoPlayer"));

const Card: React.FC<CardProps> = ({ config: { _meta, ctas, ...config }, imageRatio, headerTag }) => {
  const { brand } = useGlobalConfig();

  const configProps = useMemo(() => {
    const primaryLink = ctas?.[0];
    const secondaryLink = ctas?.[1];

    return {
      ...config,
      headerTag,
      image: config.image && {
        ...getImageSources(config.image, {
          brand,
          w: 900,
          qlt: "default",
          templates: ["poi"],
          aspect: imageRatio || "1:1",
        }),
        alt: "",
      },
      isLazy: true,
      aspectRatio: imageRatio || "3:4",
      link: {
        text: primaryLink?.text,
        href: primaryLink?.url,
      },
      secondaryLink: {
        text: secondaryLink?.text,
        href: secondaryLink?.url,
      },
      removeMargin: true,
    };
  }, [brand, config, ctas, headerTag, imageRatio]);

  return (
    <ContentCard
      videoPlayerSlot={
        config.video && <VideoPlayer hideHeadlines ratio={imageRatio} gridWrapper={false} config={config.video} />
      }
      {...configProps}
      dataTestId="content-card"
    />
  );
};

export default React.memo(Card);
